import React from "react";

import "./style.scss";

export enum NoDataIcon {
    Window = "window",
    CrossedOut = "crossedOut"
}

interface Props {
    label?: string;
    icon?: NoDataIcon;
}

export const NoData = ({ label = "Keine Daten vorhanden", icon = NoDataIcon.Window }: Props) => {
    return (
        <div className={`noData ${icon}`}>
            <p>{label}</p>
        </div>
    );
};
